import {CdkDrag, CdkDropList, CdkDropListGroup, DragDropModule} from '@angular/cdk/drag-drop';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgSelectModule} from '@ng-select/ng-select';
import {FlatpickrModule} from 'angularx-flatpickr';
import {NgxIntlTelInputModule} from 'ngx-intl-tel-input-gg';
import {CoreCommonModule} from '../../../../../../@core/common.module';
import {CoreSidebarModule} from '../../../../../../@core/components';
import {SharedModule} from '../../../../shared/shared/shared.module';
import {TableModule} from '../../../../shared/shared/table/table.module';
import {UploadFilesModule} from '../../../../shared/upload-files/upload-files.module';
import {AiGenerateActivityComponent} from './ai-generate-activity/ai-generate-activity.component';
import {BulkUploadModalComponent} from './bulk-upload-modal.component';
import {BulkUploadStepsModule} from './steps/bulk-upload-steps.module';
import { HandleDuplicatesStepComponent } from './steps/handle-duplicates-step/handle-duplicates-step.component';

const standaloneComponents = [
    HandleDuplicatesStepComponent
];

@NgModule({
  declarations: [
      BulkUploadModalComponent,
      AiGenerateActivityComponent, // Bulk Upload modal
  ],
    imports: [CommonModule, CommonModule, CoreCommonModule, CoreSidebarModule, NgbModule, NgSelectModule, SharedModule, DragDropModule, CdkDrag, CdkDropList, CdkDropListGroup, TableModule, BulkUploadStepsModule, TranslocoDirective, UploadFilesModule, FlatpickrModule, NgxIntlTelInputModule, standaloneComponents],
    exports:[
        BulkUploadModalComponent,
        AiGenerateActivityComponent
    ]
})
export class BulkUploadModule { }
